import React from 'react'

const FooterLeftPart = () => {
  return (
    <div id="FooterLPcontainer">
      <img id="FooterLPimage" src="Images/logo2.png"></img>
      <div id="FooterLPdesc">Our vision is to make all people
the best place to live for them.</div>
    </div>
  )
}

export default FooterLeftPart
